import _ from 'lodash';
import { createSelector } from 'reselect';

import { TpoDenialTreeItemType } from 'constants/tpoDenialConfiguration';

import { getCompany } from './company.selectors';

const SORT_ITERATEES = ['sortOrder', ({ name }) => _.toLower(name)];

export const selectTpoDenialCategories = createSelector(
  getCompany,
  ({ tpoDenialConfiguration }) => tpoDenialConfiguration.categories,
);

export const selectTpoDenialConfigurationTreeItems = createSelector(
  selectTpoDenialCategories,
  categories =>
    _.sortBy(categories, SORT_ITERATEES).flatMap(category => [
      {
        ...category,
        id: category.tpoDenialCategoryId,
        parentId: null,
        type: TpoDenialTreeItemType.CATEGORY,
      },
      ..._.sortBy(category.reasons, SORT_ITERATEES).map(reason => ({
        ...reason,
        id: reason.tpoDenialReasonId,
        parentId: category.tpoDenialCategoryId,
        type: TpoDenialTreeItemType.REASON,
      })),
    ]),
);
